// extracted by mini-css-extract-plugin
module.exports = {"container":"Cars_container__1PAcP","title":"Cars_title__P56Xo"};